import React from "react";
import s from "./style.module.css";
import { motion } from "framer-motion";

const IntegratedNationalDataSystem = ({
  scrollerNum,
  participants,
  pillars,
  foundations,
}) => {
  const getTextSpans = (value, breakLine, x, y, anchor) => {
    const items = value.split("\u000b");

    return items.map((d, i) => (
      <tspan
        dy={i * 20 - (items.length - 1) * 10}
        x={x}
        y={y}
        text-anchor={anchor}
      >
        {d}
      </tspan>
    ));
  };

  const state = {
    dataDots: scrollerNum >= 0,
    backgroundParticpants: scrollerNum > 0,
    participantArms: scrollerNum > 0,
    participantLabels: scrollerNum > 0,

    participantGov: scrollerNum === 1,
    participantCivil: scrollerNum === 1,
    participantAcademia: scrollerNum === 1,
    participantPrivate: scrollerNum === 1,
    participantInter: scrollerNum === 1,

    participantGovSingle: scrollerNum === 1,
    participantCivilSingle: scrollerNum === 1,
    participantAcademiaSingle: scrollerNum === 1,
    participantPrivateSingle: scrollerNum === 1,
    participantInterSingle: scrollerNum === 1,

    backgroundPillars: scrollerNum === 2,
    pillars: scrollerNum === 2,
    pillarInfra: scrollerNum === 2,
    pillarLaws: scrollerNum === 2,
    pillarEcon: scrollerNum === 2,
    pillarInst: scrollerNum === 2,

    pillarInfraSingle: scrollerNum === 2,
    pillarLawsSingle: scrollerNum === 2,
    pillarEconSingle: scrollerNum === 2,
    pillarInstSingle: scrollerNum === 2,

    backgroundFoundations: scrollerNum === 3,
    foundations: scrollerNum === 3,
    foundationsHuman: scrollerNum === 3,
    foundationsTrust: scrollerNum === 3,
    foundationsFunding: scrollerNum === 3,
    foundationsIncentives: scrollerNum === 3,
    foundationsData: scrollerNum === 3,

    foundationsHumanSingle: scrollerNum === 3,
    foundationsTrustSingle: scrollerNum === 3,
    foundationsFundingSingle: scrollerNum === 3,
    foundationsIncentivesSingle: scrollerNum === 3,
    foundationsDataSingle: scrollerNum === 3,
  };

  return (
    <div className={s.wrap}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 554 375">
        <defs />

        <defs>
          <mask id="mask-1">
            <circle id="base" cx="59" cy="59" r="58.5" fill="#fff" />
          </mask>

          <path
            id="path-1"
            d="M172.4 64C170.8 27.4 139.6-1.1 103 .5 66.4 2.1 37.9 33.3 39.5 69.9c.8 17.4 8.2 33 19.8 44.3A96.05 96.05 0 018.4 33.7c-.1-2.2-2-3.9-4.2-3.8-2.2.1-3.9 2-3.8 4.2C3 91.5 51.7 136 109 133.4A66.43 66.43 0 00172.4 64z"
          />
          <path
            id="path-3"
            d="M133.4 64C131.8 27.4 100.6-1.1 64 .5 27.4 2.1-1.1 33.3.5 69.9c1.6 36.6 32.8 65.1 69.4 63.5 10-.4 19.4-3.1 27.7-7.4a93.27 93.27 0 01-19.5 14.5 95.22 95.22 0 01-72.9 9c-2.1-.6-4.3.7-4.9 2.8-.6 2.1.7 4.3 2.8 4.9 26.8 7.4 54.8 3.9 79-9.8 24.2-13.7 41.5-36 48.9-62.8 1.9-6.5 2.8-13.4 2.4-20.6z"
          />
          <path
            id="path-5"
            d="M148.2 77.5c-5.6-27.2-21.4-50.6-44.6-65.9C92.3 4.1 78.6 0 64 .6 27.4 2.2-1.1 33.4.5 70c1.6 36.6 32.8 65.1 69.4 63.5 36.6-1.6 65.1-32.8 63.5-69.4-.1-2.7-.4-5.4-.9-8 3.5 7.2 6.2 14.9 7.8 23 5.1 25.1.2 50.7-13.9 72.1a4 4 0 001.1 5.5 4 4 0 005.5-1.1c15.4-23.2 20.8-50.9 15.2-78.1z"
          />
          <path
            id="path-7"
            d="M171.7 39.5A103.39 103.39 0 00102 1C96.5.4 90.9.2 85.5.4c-21.8 1-42.6 8.7-60 22.6a66.22 66.22 0 00-25 54.9c1.6 36.6 32.8 65.1 69.4 63.5 36.6-1.6 65.1-32.8 63.5-69.4-1.4-32.3-25.8-58.2-56.5-62.8C84.8 8.1 93 8 101.2 8.9a95.32 95.32 0 0164.3 35.6 3.98 3.98 0 106.2-5z"
          />
          <path
            id="path-9"
            d="M135.4 108c-1.6-36.6-32.8-65.1-69.4-63.5-24.9 1.1-46 15.8-56.4 36.6 5.8-32.3 27.9-60.9 60.8-73.2 2.1-.8 3.1-3.1 2.3-5.2C72.1 1 70.5 0 68.8.1c-.4 0-.8.1-1.2.3C14.3 20.4-13 79.7 6.3 133.1c.1.3.2.6.3.8 0 .1.1.3.1.4 9.9 26.2 35.8 44.4 65.2 43.1 36.7-1.6 65.2-32.7 63.5-69.4z"
          />
        </defs>
        <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
          <g id="Story-10---Viz1_NEW">
            <g transform="translate(125 8)">
              <motion.g
                initial={{ opacity: 0 }}
                animate={{
                  opacity: state.backgroundFoundations ? 1 : 0,
                  scale: state.backgroundFoundations ? 1 : 0.55,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
                id="Background-fouindations"
                fill="#EE6047"
                stroke="#DE2414"
                strokeLinecap="round"
              >
                <circle className={s.dot} cx="164" cy="164" r="164" />
              </motion.g>
            </g>

            <g transform="translate(155 38)">
              <motion.g
                initial={{ opacity: 0 }}
                animate={{
                  opacity: state.backgroundPillars ? 1 : 0,
                  scale: state.backgroundPillars ? 1 : 0.55,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
                id="Background-pillars"
                fill="#F1806C"
                stroke="#DE2414"
                strokeLinecap="round"
              >
                {/* <circle className={s.dot} cx="134" cy="134" r="133.3" /> */}
              </motion.g>
            </g>
            <g transform="translate(182 65)">
              <motion.g
                id="Background-participants"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: state.backgroundParticpants ? 1 : 0,
                  scale: state.backgroundParticpants ? 1 : 0.55,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
              >
                <g id="Group-7" transform="translate(0 .2)">
                  <circle
                    id="Oval"
                    cx="107"
                    cy="106.8"
                    r="106.8"
                    fill="#F8A08F"
                    stroke="#DE2414"
                  />
                  <g id="Group" fill="#F5A1BD" transform="translate(40 39.8)">
                    <path
                      id="Shape"
                      d="M64 .6c36.6-1.6 67.8 26.8 69.4 63.5 1.6 36.7-26.8 67.8-63.5 69.4C33.3 135.1 2.1 106.7.5 70-1.1 33.3 27.4 2.2 64 .6zm5.6 124.8a58.7 58.7 0 0053.8-42.9c1.6-5.8 2.3-11.9 2-18.2a58.52 58.52 0 00-26.2-46.2c-10-6.6-22-10.2-34.8-9.6-12.8.6-24.5 5.3-33.8 12.7a58.38 58.38 0 00-22 48.3c.3 6.3 1.6 12.3 3.7 17.9a58.3 58.3 0 0057.3 38z"
                    />
                    <circle
                      id="Oval"
                      cx="67"
                      cy="67"
                      r="66.5"
                      stroke="#DE2414"
                      strokeLinecap="round"
                    />
                  </g>
                  <path
                    id="Shape"
                    stroke="#DE2414"
                    strokeLinecap="round"
                    d="M109.6 165.2c6.8-.3 13.2-1.7 19.2-4.1m-76.6-33.8c2.3 6.2 5.7 12 9.9 17m8.5-83.2c-5.1 4.1-9.5 8.9-12.9 14.4M139.2 58c-5.4-3.6-11.4-6.3-17.8-7.9m42 72.3c1.6-5.8 2.3-11.9 2-18.2 0-.4 0-.8-.1-1.2"
                  />
                </g>
              </motion.g>
            </g>

            <g transform="translate(230 113)" mask="url(#mask-1)">
              <motion.g
                id="center-dots"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: state.dataDots ? 1 : 0,
                  scale: state.dataDots ? 1 : 0,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
              >
                <g
                  id="Background-data"
                  fill="#F5A1BD"
                  stroke="#DE2414"
                  strokeLinecap="round"
                >
                  <circle className={s.dot} cx="59" cy="59" r="58.5" />
                </g>
                <g fill="#481F7C" opacity=".8" transform="translate(4 5.5)">
                  <motion.g
                    originX={100}
                    originY={100}
                    initial={{ rotate: 0 }}
                    animate={{
                      rotate: -360,
                      // opacity: 1,
                      fill: state.participantGovSingle ? "#fff" : "",
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 20,
                      ease: "linear",
                    }}
                  >
                    <circle className={s.dot} cx="9.6" cy="32.2" r="2" />
                    <circle className={s.dot} cx="57.9" cy="58" r="2" />
                    <circle className={s.dot} cx="35.2" cy="9.7" r="2" />
                    <circle className={s.dot} cx="18" cy="59.1" r="2" />
                    <circle className={s.dot} cx="92.8" cy="39.4" r="2" />
                    <circle className={s.dot} cx="53.5" cy="99.1" r="2" />
                    <circle className={s.dot} cx="81.4" cy="63.7" r="2" />
                    <circle className={s.dot} cx="13.2" cy="34.2" r="2" />
                    <circle className={s.dot} cx="4" cy="50.3" r="2" />
                    <circle className={s.dot} cx="56.9" cy="54" r="2" />
                    <circle className={s.dot} cx="2" cy="57" r="2" />
                    <circle className={s.dot} cx="29.9" cy="95" r="2" />
                    <circle className={s.dot} cx="61.9" cy="38.8" r="2" />
                    <circle className={s.dot} cx="9" cy="75" r="2" />
                    <circle className={s.dot} cx="68.4" cy="13.6" r="2" />
                    <circle className={s.dot} cx="69" cy="86.4" r="2" />
                    <circle className={s.dot} cx="96.6" cy="26.5" r="2" />
                    <circle className={s.dot} cx="90.1" cy="44.9" r="2" />
                    <circle className={s.dot} cx="73.8" cy="101.1" r="2" />
                    <circle className={s.dot} cx="28" cy="25.3" r="2" />
                    <circle className={s.dot} cx="76.3" cy="59.1" r="2" />
                    <circle className={s.dot} cx="82.7" cy="83.8" r="2" />
                    <circle className={s.dot} cx="90.2" cy="86.3" r="2" />
                    <circle className={s.dot} cx="106" cy="52" r="2" />
                    <circle className={s.dot} cx="49" cy="2" r="2" />
                    <circle className={s.dot} cx="103.3" cy="45.8" r="2" />
                    <circle className={s.dot} cx="46.9" cy="52.7" r="2" />
                    <circle className={s.dot} cx="48.6" cy="20.3" r="2" />
                    <circle className={s.dot} cx="24.7" cy="76.1" r="2" />
                  </motion.g>
                  <motion.g
                    initial={{ rotate: 0 }}
                    animate={{
                      rotate: -360,
                      // opacity: 0,
                      fill: state.participantCivilSingle ? "#fff" : "",
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 15,
                      ease: "linear",
                    }}
                  >
                    <circle className={s.dot} cx="24" cy="52" r="2" />
                    <circle className={s.dot} cx="84.9" cy="77.1" r="2" />
                    <circle className={s.dot} cx="34.2" cy="40.8" r="2" />
                    <circle className={s.dot} cx="88.4" cy="34.5" r="2" />
                    <circle className={s.dot} cx="9" cy="60" r="2" />
                    <circle className={s.dot} cx="81.6" cy="96.5" r="2" />
                    <circle className={s.dot} cx="48.6" cy="76.1" r="2" />
                    <circle className={s.dot} cx="92.1" cy="56.6" r="2" />
                    <circle className={s.dot} cx="75.8" cy="7.7" r="2" />
                    <circle className={s.dot} cx="18" cy="66" r="2" />
                    <circle className={s.dot} cx="97" cy="73.1" r="2" />
                    <circle className={s.dot} cx="99.6" cy="22.2" r="2" />
                    <circle className={s.dot} cx="49" cy="32" r="2" />
                    <circle className={s.dot} cx="102.4" cy="28.5" r="2" />
                    <circle className={s.dot} cx="59.9" cy="103" r="2" />
                    <circle className={s.dot} cx="23.2" cy="19.8" r="2" />
                    <circle className={s.dot} cx="97" cy="61" r="2" />
                    <circle className={s.dot} cx="14" cy="89" r="2" />
                    <circle className={s.dot} cx="100.9" cy="54.6" r="2" />
                    <circle className={s.dot} cx="8.5" cy="40.2" r="2" />
                    <circle className={s.dot} cx="8.3" cy="27.3" r="2" />
                    <circle className={s.dot} cx="43.5" cy="37.9" r="2" />
                    <circle className={s.dot} cx="56" cy="12.2" r="2" />
                    <circle className={s.dot} cx="66" cy="31" r="2" />
                    <circle className={s.dot} cx="31.2" cy="75.9" r="2" />
                    <circle className={s.dot} cx="35.1" cy="52.6" r="2" />
                    <circle className={s.dot} cx="64.8" cy="72.2" r="2" />
                    <circle className={s.dot} cx="39.4" cy="20.7" r="2" />
                    <circle className={s.dot} cx="57" cy="10" r="2" />
                    <circle className={s.dot} cx="87.9" cy="77.7" r="2" />
                    <circle className={s.dot} cx="43.4" cy="11" r="2" />
                    <circle className={s.dot} cx="80.1" cy="20.1" r="2" />
                    <circle className={s.dot} cx="86.6" cy="11.7" r="2" />
                    <circle className={s.dot} cx="65.8" cy="66.9" r="2" />
                  </motion.g>

                  <motion.g
                    initial={{ rotate: 0 }}
                    animate={{
                      rotate: -360,
                      // opacity: 0,
                      fill: state.participantAcademiaSingle ? "#fff" : "",
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 10,
                      ease: "linear",
                    }}
                  >
                    <circle className={s.dot} cx="67.5" cy="102.7" r="2" />
                    <circle className={s.dot} cx="24.1" cy="83.2" r="2" />
                    <circle className={s.dot} cx="79.2" cy="16.2" r="2" />
                    <circle className={s.dot} cx="91" cy="45.2" r="2" />
                    <circle className={s.dot} cx="40.4" cy="74.9" r="2" />
                    <circle className={s.dot} cx="36.4" cy="4.2" r="2" />
                    <circle className={s.dot} cx="51.9" cy="64.3" r="2" />
                    <circle className={s.dot} cx="39.5" cy="69.3" r="2" />
                    <circle className={s.dot} cx="24" cy="35.7" r="2" />
                    <circle className={s.dot} cx="67.5" cy="41.9" r="2" />
                    <circle className={s.dot} cx="37.6" cy="35.9" r="2" />
                    <circle className={s.dot} cx="41.7" cy="100.6" r="2" />
                    <circle className={s.dot} cx="80.1" cy="90.6" r="2" />
                    <circle className={s.dot} cx="16.9" cy="27" r="2" />
                    <circle className={s.dot} cx="59.8" cy="82.3" r="2" />
                    <circle className={s.dot} cx="81" cy="70.4" r="2" />
                    <circle className={s.dot} cx="50.9" cy="13.3" r="2" />
                    <circle className={s.dot} cx="74" cy="36.2" r="2" />
                    <circle className={s.dot} cx="73" cy="94.3" r="2" />
                    <circle className={s.dot} cx="61.5" cy="60.9" r="2" />
                    <circle className={s.dot} cx="57.1" cy="48.4" r="2" />
                    <circle className={s.dot} cx="98.3" cy="35.9" r="2" />
                    <circle className={s.dot} cx="103.6" cy="73.5" r="2" />
                    <circle className={s.dot} cx="8.3" cy="47.8" r="2" />
                    <circle className={s.dot} cx="82.1" cy="50.3" r="2" />
                    <circle className={s.dot} cx="58.6" cy="33.7" r="2" />
                    <circle className={s.dot} cx="78.9" cy="40.2" r="2" />
                    <circle className={s.dot} cx="55.5" cy="80.3" r="2" />
                    <circle className={s.dot} cx="44.4" cy="60.3" r="2" />
                  </motion.g>

                  <motion.g
                    initial={{ rotate: 0 }}
                    animate={{
                      rotate: -360,
                      // opacity: 0,
                      fill: state.participantPrivateSingle ? "#fff" : "",
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 30,
                      ease: "linear",
                    }}
                  >
                    <circle className={s.dot} cx="62" cy="4" r="2" />
                    <circle className={s.dot} cx="42.6" cy="79.2" r="2" />
                    <circle className={s.dot} cx="28" cy="68" r="2" />
                    <circle className={s.dot} cx="57.5" cy="21.3" r="2" />
                    <circle className={s.dot} cx="77" cy="79.3" r="2" />
                    <circle className={s.dot} cx="58.3" cy="23.1" r="2" />
                    <circle className={s.dot} cx="70.5" cy="90" r="2" />
                    <circle className={s.dot} cx="77" cy="29.5" r="2" />
                    <circle className={s.dot} cx="34.5" cy="71.8" r="2" />
                    <circle className={s.dot} cx="72.5" cy="66.3" r="2" />
                    <circle className={s.dot} cx="66.7" cy="79.3" r="2" />
                    <circle className={s.dot} cx="35.5" cy="23.7" r="2" />
                    <circle className={s.dot} cx="23.6" cy="42.1" r="2" />
                    <circle className={s.dot} cx="43" cy="45" r="2" />
                    <circle className={s.dot} cx="16" cy="52.3" r="2" />
                    <circle className={s.dot} cx="64.8" cy="12.7" r="2" />
                    <circle className={s.dot} cx="76.4" cy="53" r="2" />
                    <circle className={s.dot} cx="35.7" cy="64.5" r="2" />
                    <circle className={s.dot} cx="22" cy="88" r="2" />
                    <circle className={s.dot} cx="100.3" cy="73.6" r="2" />
                    <circle className={s.dot} cx="14" cy="76" r="2" />
                    <circle className={s.dot} cx="45.7" cy="90.9" r="2" />
                    <circle className={s.dot} cx="49.8" cy="90" r="2" />
                    <circle className={s.dot} cx="79.1" cy="87.3" r="2" />
                    <circle className={s.dot} cx="64" cy="48.3" r="2" />
                    <circle className={s.dot} cx="44.4" cy="27" r="2" />
                    <circle className={s.dot} cx="33.2" cy="20.2" r="2" />
                    <circle className={s.dot} cx="25" cy="9" r="2" />
                    <circle className={s.dot} cx="8.9" cy="65.4" r="2" />
                    <circle className={s.dot} cx="107" cy="63" r="2" />
                    <circle className={s.dot} cx="71.4" cy="11.7" r="2" />
                    <circle className={s.dot} cx="89.1" cy="17" r="2" />
                  </motion.g>
                  <motion.g
                    initial={{ rotate: 0 }}
                    animate={{
                      // opacity: 0,
                      rotate: -360,
                      fill: state.participantInterSingle ? "#fff" : "",
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 25,
                      ease: "linear",
                    }}
                  >
                    <circle className={s.dot} cx="56.6" cy="27.5" r="2" />
                    <circle className={s.dot} cx="53.8" cy="66" r="2" />
                    <circle className={s.dot} cx="105.7" cy="39.4" r="2" />
                    <circle className={s.dot} cx="91.2" cy="31.1" r="2" />
                    <circle className={s.dot} cx="69.1" cy="75.9" r="2" />
                    <circle className={s.dot} cx="39.7" cy="55.7" r="2" />
                    <circle className={s.dot} cx="100.3" cy="79.7" r="2" />
                    <circle className={s.dot} cx="58" cy="93" r="2" />
                    <circle className={s.dot} cx="77.2" cy="50.2" r="2" />
                    <circle className={s.dot} cx="63.9" cy="18.9" r="2" />
                    <circle className={s.dot} cx="91" cy="70" r="2" />
                    <circle className={s.dot} cx="34.3" cy="35.4" r="2" />
                    <circle className={s.dot} cx="64.4" cy="10.2" r="2" />
                    <circle className={s.dot} cx="104.4" cy="43.9" r="2" />
                    <circle className={s.dot} cx="95" cy="92.2" r="2" />
                    <circle className={s.dot} cx="40.1" cy="9.3" r="2" />
                    <circle className={s.dot} cx="50.6" cy="105" r="2" />
                    <circle className={s.dot} cx="70.4" cy="21.8" r="2" />
                    <circle className={s.dot} cx="85.5" cy="36.3" r="2" />
                    <circle className={s.dot} cx="51.4" cy="17.2" r="2" />
                    <circle className={s.dot} cx="90.2" cy="25.2" r="2" />
                    <circle className={s.dot} cx="12.1" cy="43.2" r="2" />
                    <circle className={s.dot} cx="34.5" cy="81.2" r="2" />
                    <circle className={s.dot} cx="18.3" cy="40.4" r="2" />
                    <circle className={s.dot} cx="59.7" cy="66.6" r="2" />
                    <circle className={s.dot} cx="82.9" cy="23.1" r="2" />
                    <circle className={s.dot} cx="38.4" cy="92.2" r="2" />
                    <circle className={s.dot} cx="68.4" cy="4" r="2" />
                    <circle className={s.dot} cx="53.8" cy="41.9" r="2" />
                    <circle className={s.dot} cx="34" cy="55.2" r="2" />
                    <circle className={s.dot} cx="15" cy="18.1" r="2" />
                    <circle className={s.dot} cx="82.4" cy="16.3" r="2" />
                    <circle className={s.dot} cx="73.8" cy="47.4" r="2" />
                    <circle className={s.dot} cx="20.3" cy="42.9" r="2" />
                  </motion.g>
                </g>
              </motion.g>
            </g>

            <g transform="translate(183 61)">
              <motion.g
                initial={{ opacity: 0 }}
                animate={{
                  opacity: state.participantArms ? 1 : 0,
                  scale: state.backgroundParticpants ? 1 : 0.5,
                  rotate: state.backgroundParticpants ? 0 : 20,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
                id="particpants-arms"
              >
                <g id="Group-10" transform="translate(0 44)">
                  <g id="Arm_5">
                    <path
                      id="Path"
                      fill="#F5A1BD"
                      stroke="#DE2414"
                      d="M109 133.4C51.7 136 3 91.4.5 34.1c-.1-2.2 1.6-4.1 3.8-4.2 2.2-.1 4.1 1.6 4.2 3.8 2.4 52.9 47.3 94 100.2 91.6"
                    />
                    <g id="Clipped">
                      <mask id="mask-2" fill="#fff">
                        <use xlinkHref="#path-1" />
                      </mask>
                      <g id="Group" mask="url(#mask-2)">
                        <g transform="translate(2 -73)">
                          <circle
                            className={s.dot}
                            cx="102.3"
                            cy="102.5"
                            r="100"
                          />
                          <g id="Group" strokeWidth="1" opacity=".8">
                            <motion.path
                              initial={{ rotate: 0 }}
                              animate={{
                                rotate: -360,
                                fill: state.participantInterSingle
                                  ? "#fff"
                                  : "#481F7C",
                              }}
                              transition={{
                                repeat: Infinity,
                                duration: 25,
                                ease: "linear",
                                fill: { duration: 0.5 },
                              }}
                              id="Shape"
                              fill="#481F7C"
                              d="M95.8 204.3c-1.1-.1-1.9-1-1.9-2.1.1-1.1 1-1.9 2.1-1.9 1.1.1 1.9 1 1.9 2.1-.1 1.1-1 1.9-2 1.9h-.1zm-12.1-1.5c-1.1-.2-1.8-1.2-1.6-2.3.2-1.1 1.2-1.8 2.3-1.6 1.1.2 1.8 1.2 1.6 2.3-.2 1-1 1.6-2 1.6-.1.1-.2.1-.3 0zm-8-1.8a2 2 0 01-1.4-2.5c.3-1.1 1.4-1.7 2.4-1.4a2 2 0 011.4 2.5c-.2.9-1 1.5-1.9 1.5-.1 0-.3 0-.5-.1zm65.2-6.2c-.5-1 0-2.2 1-2.6 1-.4 2.2 0 2.6 1 .4 1 0 2.2-1 2.6-.3.1-.5.2-.8.2-.7 0-1.5-.4-1.8-1.2zm10.8-5.2c-.6-1-.3-2.2.7-2.7 1-.6 2.2-.3 2.7.7.6 1 .3 2.2-.7 2.7-.3.2-.7.3-1 .3-.7-.1-1.4-.4-1.7-1zm-112.2-6.7c-.9-.7-1-1.9-.3-2.8.7-.9 1.9-1 2.8-.3.9.7 1 1.9.3 2.8-.4.5-1 .8-1.6.8-.4-.1-.8-.2-1.2-.5zm-9.2-8.1c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6zm-5.5-6c-.7-.8-.6-2.1.2-2.8.8-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8-.4.3-.8.5-1.3.5-.6 0-1.1-.2-1.5-.7zm156.8-5.3c-.9-.7-1.1-1.9-.4-2.8.7-.9 1.9-1.1 2.8-.4.9.6 1.1 1.9.4 2.8-.4.5-1 .8-1.6.8-.4 0-.8-.2-1.2-.4zm4.7-6.6c-.9-.6-1.2-1.8-.6-2.8.6-.9 1.8-1.2 2.8-.6.9.6 1.2 1.8.6 2.8-.4.6-1 1-1.7 1-.5 0-.8-.1-1.1-.4zm5.9-10.4c-1-.5-1.4-1.7-1-2.7.5-1 1.7-1.4 2.7-1 1 .5 1.4 1.7 1 2.7-.3.7-1.1 1.2-1.8 1.2a2 2 0 01-.9-.2zM5.1 133.4c-.3-1 .2-2.2 1.3-2.5 1.1-.3 2.2.2 2.5 1.3.3 1.1-.2 2.2-1.3 2.5-.2.1-.4.1-.6.1-.9 0-1.7-.6-1.9-1.4zm-3-11.9c-.2-1.1.5-2.1 1.6-2.3 1.1-.2 2.1.5 2.3 1.6.2 1.1-.5 2.1-1.6 2.3H4c-.9.1-1.7-.6-1.9-1.6zm-1.2-8c-.1-1.1.7-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.8 2.2h-.2c-1 0-1.9-.8-2-1.8zm201.3-5.4c-1.1 0-2-1-1.9-2.1 0-1.1 1-2 2.1-1.9 1.1 0 2 1 1.9 2.1-.1 1-1 1.9-2.1 1.9zm-2-9.9c-.1-1.1.8-2 1.9-2.1 1.1 0 2 .8 2.1 1.9 0 1.1-.8 2-1.9 2.1h-.1c-1 0-1.9-.9-2-1.9zm-2.9-19.9c-.3-1.1.4-2.2 1.4-2.4 1.1-.3 2.2.4 2.4 1.4.3 1.1-.4 2.2-1.4 2.4-.2 0-.3.1-.5.1-.9 0-1.7-.6-1.9-1.5zM6 75.6c-1.1-.3-1.7-1.4-1.3-2.5.3-1 1.4-1.6 2.5-1.3 1.1.3 1.7 1.4 1.3 2.5-.3.9-1 1.4-1.9 1.4-.2 0-.4 0-.6-.1zm189.1-4.8c-.4-1 .2-2.2 1.2-2.5 1-.4 2.2.2 2.5 1.2.4 1-.2 2.2-1.2 2.5-.2.1-.4.1-.7.1-.8 0-1.6-.5-1.8-1.3zM9.9 64.3c-1-.5-1.5-1.6-1-2.6.4-1 1.6-1.5 2.6-1 1 .4 1.5 1.6 1 2.6-.3.8-1.1 1.2-1.8 1.2-.3-.1-.6-.1-.8-.2zm180.7-4.4a2 2 0 01.9-2.7 2 2 0 012.7.9 2 2 0 01-.9 2.7c-.3.1-.6.2-.9.2-.8 0-1.5-.4-1.8-1.1zM13.2 57c-1-.5-1.3-1.7-.8-2.7.5-1 1.7-1.3 2.7-.8 1 .5 1.3 1.7.8 2.7-.4.7-1 1-1.8 1-.2 0-.6 0-.9-.2zM167 28.9c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.5-1 .7-1.5.7-.4 0-.9-.1-1.3-.5zm-129-3c-.7-.9-.6-2.1.3-2.8.9-.7 2.1-.6 2.8.3.7.9.6 2.1-.3 2.8-.4.3-.8.5-1.3.5s-1.1-.3-1.5-.8zM160.9 24c-.9-.7-1.1-1.9-.4-2.8.7-.9 1.9-1.1 2.8-.4.9.7 1.1 1.9.4 2.8-.4.5-1 .8-1.6.8-.4 0-.8-.2-1.2-.4zM47.6 18.8c-.6-.9-.3-2.2.6-2.8.9-.6 2.2-.3 2.8.6.6.9.3 2.2-.6 2.8-.3.2-.7.3-1 .3-.7 0-1.4-.3-1.8-.9zm103.5-1.3c-1-.5-1.3-1.8-.7-2.7.5-1 1.8-1.3 2.7-.7 1 .5 1.3 1.8.7 2.7-.4.6-1 1-1.7 1-.3 0-.7-.1-1-.3zm-96.6-2.8c-.5-1-.1-2.2.8-2.7 1-.5 2.2-.1 2.7.8a2 2 0 01-.9 2.7c-.3.2-.6.2-.9.2-.7 0-1.4-.3-1.7-1zm59.7-9.5c-1.1-.1-1.9-1.1-1.7-2.2.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2-.1 1-1 1.8-2 1.8-.2.1-.3 0-.3 0zM92.5 3c-.1-1.1.7-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.8 2.2h-.2c-1.1 0-2-.8-2-1.8zm13.9 1.6c-1.1 0-2-1-1.9-2.1 0-1.1 1-2 2.1-1.9 1.1 0 2 1 1.9 2.1-.1 1.1-1 1.9-2.1 1.9z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <circle
                    id="Oval"
                    cx="4.4"
                    cy="34"
                    r="4"
                    fill="#FFF"
                    stroke="#DE2414"
                  />
                </g>
                <g id="Group-12" transform="translate(39 44)">
                  <g id="Arm_4">
                    <path
                      id="Path"
                      fill="#F5A1BD"
                      stroke="#DE2414"
                      d="M131.1 84.7c-7.4 26.8-24.8 49.1-48.9 62.8a103.35 103.35 0 01-79 9.8c-2.1-.6-3.4-2.8-2.8-4.9.6-2.1 2.8-3.4 4.9-2.8 24.7 6.8 50.6 3.6 72.9-9a95.15 95.15 0 0045.2-57.9"
                    />
                    <g id="Clipped">
                      <mask id="mask-4" fill="#fff">
                        <use xlinkHref="#path-3" />
                      </mask>
                      <g id="Group" mask="url(#mask-4)">
                        <g transform="translate(-72 -45)">
                          <circle
                            className={s.dot}
                            cx="102.9"
                            cy="102"
                            r="100"
                          />
                          <g id="Group" strokeWidth="1" opacity=".8">
                            <motion.path
                              initial={{ rotate: 0 }}
                              animate={{
                                rotate: -360,
                                fill: state.participantPrivateSingle
                                  ? "#fff"
                                  : "#481F7C",
                              }}
                              transition={{
                                repeat: Infinity,
                                duration: 25,
                                ease: "linear",
                                fill: { duration: 0.5 },
                              }}
                              id="Shape"
                              d="M102.1 204a2 2 0 01-2-2c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2zm10-2.4c-.1-1.1.7-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.8 2.2h-.2c-1 0-1.9-.8-2-1.8zm-26.2 1c-1.1-.2-1.8-1.2-1.6-2.3.2-1.1 1.2-1.8 2.3-1.6 1.1.2 1.8 1.2 1.6 2.3-.2 1-1 1.7-2 1.7-.1-.1-.2-.1-.3-.1zm34.1-2c-.2-1.1.5-2.1 1.6-2.3 1.1-.2 2.1.5 2.4 1.6.2 1.1-.5 2.1-1.6 2.3h-.4c-.9 0-1.8-.7-2-1.6zm-42.1.3c-1.1-.3-1.7-1.4-1.5-2.4.3-1.1 1.4-1.7 2.4-1.5 1.1.3 1.7 1.4 1.5 2.4-.2.9-1 1.5-1.9 1.5-.2.1-.3.1-.5 0zm57.6-4.3a2 2 0 011.2-2.6c1-.4 2.2.2 2.6 1.2.4 1-.2 2.2-1.2 2.6-.2.1-.5.1-.7.1-.8 0-1.6-.5-1.9-1.3zm-69.3.6c-1-.4-1.5-1.6-1.2-2.6.4-1 1.5-1.5 2.6-1.2 1 .4 1.5 1.5 1.2 2.6-.3.8-1.1 1.3-1.9 1.3-.2.1-.4 0-.7-.1zm80.4-5.2a2 2 0 01.9-2.7 2 2 0 012.7.9 2 2 0 01-.9 2.7c-.3.2-.6.2-.9.2-.8-.1-1.5-.4-1.8-1.1zm-95.1-1.8c-1-.6-1.3-1.8-.7-2.7.5-.9 1.8-1.3 2.7-.7 1 .5 1.3 1.8.7 2.7-.4.6-1 1-1.7 1-.3 0-.6-.1-1-.3zm102.1-2c-.6-.9-.3-2.2.6-2.8.9-.6 2.2-.3 2.8.6.6.9.3 2.2-.6 2.8-.3.2-.7.3-1 .3-.7 0-1.4-.3-1.8-.9zm-108.9-2.4c-.9-.6-1.1-1.9-.5-2.8.6-.9 1.9-1.1 2.8-.5.9.6 1.1 1.9.5 2.8-.4.5-1 .8-1.6.8-.5.1-.9 0-1.2-.3zm122-6.8c-.7-.8-.6-2.1.2-2.8.8-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8-.4.3-.8.5-1.3.5s-1.1-.3-1.5-.7zM35 178.2c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.4-1 .7-1.5.7-.4 0-.9-.1-1.3-.5zm140.5-7.4c-.8-.7-.9-2-.1-2.8.8-.8 2-.9 2.8-.1.8.7.9 2 .1 2.8-.4.4-.9.7-1.5.7-.4-.1-.9-.3-1.3-.6zm-151.7-4.3c-.7-.9-.6-2.1.3-2.8.9-.7 2.1-.6 2.8.3.7.9.6 2.1-.3 2.8-.4.3-.8.5-1.3.5-.6-.1-1.1-.4-1.5-.8zm157-1.7c-.9-.7-1-1.9-.4-2.8.7-.9 1.9-1 2.8-.4.9.7 1 1.9.4 2.8-.4.5-1 .8-1.6.8-.4 0-.9-.1-1.2-.4zm-161.9-4.9c-.6-.9-.4-2.2.5-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.2-.5 2.8-.3.2-.7.4-1.1.4-.7 0-1.3-.3-1.7-.9zm170.9-8.3c-1-.5-1.3-1.8-.8-2.7.5-1 1.7-1.3 2.7-.8 1 .5 1.3 1.7.8 2.7a2 2 0 01-1.8 1c-.3 0-.6-.1-.9-.2zm-177.2-2.1c-.5-1-.1-2.2.8-2.7 1-.5 2.2-.1 2.7.8.5 1 .1 2.2-.8 2.7-.3.2-.6.2-.9.2-.8 0-1.5-.4-1.8-1zm182.4-8.7c-1-.4-1.5-1.6-1.1-2.6.4-1 1.6-1.5 2.6-1.1 1 .4 1.5 1.6 1.1 2.6-.3.8-1.1 1.3-1.9 1.3-.2-.1-.4-.1-.7-.2zM6.1 134.5c-.4-1 .2-2.2 1.3-2.5 1-.3 2.2.2 2.5 1.2.3 1-.2 2.2-1.3 2.5-.2.1-.4.1-.6.1-.8 0-1.6-.5-1.9-1.3zm191.7-1.2c-1.1-.3-1.7-1.4-1.3-2.5.3-1 1.4-1.7 2.5-1.3 1 .3 1.6 1.4 1.3 2.5a2 2 0 01-1.9 1.4c-.2 0-.4 0-.6-.1zM3.9 126.6c-.3-1.1.4-2.2 1.5-2.4 1.1-.3 2.2.4 2.4 1.5.3 1.1-.4 2.2-1.5 2.4-.2 0-.3.1-.5.1-.9 0-1.7-.6-1.9-1.6zm197.7-8.8c-1.1-.1-1.8-1.2-1.7-2.3a2.1 2.1 0 012.3-1.7c1.1.2 1.9 1.2 1.7 2.3-.1 1-1 1.7-2 1.7h-.3zm-200-3.2c-.1-1.1.6-2.1 1.7-2.2 1.1-.1 2.1.6 2.2 1.7.1 1.1-.6 2.1-1.7 2.2h-.2c-1 .1-1.9-.7-2-1.7zm1.2-14.2c-1.1 0-2-1-1.9-2.1 0-1.1 1-2 2.1-1.9 1.1.1 2 1 1.9 2.1 0 1.1-.9 1.9-2.1 1.9.1 0 0 0 0 0zm.5-8c-1.1-.1-1.9-1.1-1.8-2.2.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2-.1 1-1 1.8-2 1.8h-.2zm195.2-11.9c-.2-1.1.4-2.2 1.5-2.4 1.1-.2 2.1.4 2.4 1.5.2 1.1-.4 2.1-1.5 2.4h-.4c-1 0-1.8-.6-2-1.5zm-193.3.1c-1.1-.3-1.7-1.3-1.5-2.4.3-1.1 1.3-1.7 2.4-1.5 1.1.3 1.7 1.3 1.5 2.4-.2.9-1 1.5-1.9 1.5h-.5zm190-11.4c-.4-1 .2-2.2 1.2-2.6 1-.4 2.2.2 2.5 1.2.4 1-.2 2.2-1.2 2.5-.2.1-.4.1-.7.1-.7.1-1.5-.4-1.8-1.2zM9.8 65.3c-1-.4-1.5-1.6-1.1-2.6.4-1 1.6-1.5 2.6-1.1 1 .4 1.5 1.6 1.1 2.6-.3.8-1.1 1.2-1.8 1.2-.3 0-.5 0-.8-.1zm182.5-3.4c-.5-1 0-2.2 1-2.6 1-.5 2.2 0 2.6 1 .5 1 0 2.2-1 2.6-.3.1-.5.2-.8.2-.8 0-1.5-.4-1.8-1.2zM13 58a2 2 0 01-.9-2.7 2 2 0 012.7-.9 2 2 0 01.9 2.7c-.3.7-1 1.1-1.8 1.1-.3 0-.6-.1-.9-.2zm171.7-9.8c-.6-.9-.3-2.2.6-2.8.9-.6 2.2-.3 2.8.6.6.9.3 2.2-.6 2.8a2.1 2.1 0 01-2.8-.6zm-165.8-.7c-.9-.6-1.2-1.9-.5-2.8.6-.9 1.9-1.2 2.8-.5.9.6 1.1 1.9.5 2.8-.4.6-1 .9-1.7.9-.3 0-.7-.1-1.1-.4zm158.8-8.7c-.7-.8-.6-2.1.2-2.8.8-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8-.4.3-.8.5-1.3.5s-1.1-.3-1.5-.7zm-149-3.9c-.8-.8-.8-2-.1-2.8.8-.8 2-.8 2.8-.1.8.8.8 2 .1 2.8-.4.4-.9.6-1.5.6-.4 0-.9-.2-1.3-.5zM172.4 33c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0 .8.8.8 2.1 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6zM34.3 29.2c-.7-.8-.7-2.1.2-2.8.8-.7 2.1-.7 2.8.1.7.8.7 2.1-.1 2.8-.4.3-.9.5-1.3.5-.7 0-1.2-.2-1.6-.6zm126.3-6.4c-.9-.7-1.1-1.9-.4-2.8.7-.9 1.9-1.1 2.8-.4.9.7 1.1 1.9.4 2.8-.4.5-1 .8-1.6.8-.5 0-.9-.2-1.2-.4zM43.5 21.5c-.6-.9-.4-2.1.5-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.1-.5 2.8-.4.2-.8.4-1.2.4-.6-.1-1.2-.4-1.6-.9zm107.2-5.1c-1-.5-1.3-1.8-.8-2.7.5-1 1.8-1.3 2.7-.8 1 .5 1.3 1.8.8 2.7-.4.7-1 1-1.7 1-.4.1-.7 0-1-.2zm-93.6-3.3a2 2 0 01.9-2.7 2 2 0 012.7.9 2 2 0 01-.9 2.7c-.3.1-.6.2-.9.2-.7 0-1.4-.4-1.8-1.1zm86.6-.2c-1-.5-1.5-1.6-1-2.7.5-1 1.7-1.4 2.7-1 1 .5 1.5 1.6 1 2.6-.3.7-1.1 1.2-1.8 1.2-.4.1-.7 0-.9-.1zM64.4 9.7c-.4-1 .1-2.2 1.1-2.6 1-.4 2.2.1 2.6 1.1.4 1-.1 2.2-1.1 2.6-.2.1-.5.1-.7.1-.9.1-1.6-.4-1.9-1.2zm64.5-2.2c-.1 0-.2 0-.2-.1h-.2a2 2 0 01-1.4-2.5 2 2 0 012.5-1.4c.1 0 .2 0 .2.1h.2a2 2 0 011.4 2.5c-.2.9-1 1.5-1.9 1.5-.2 0-.4 0-.6-.1zM75.7 5.7c-.3-1.1.4-2.2 1.4-2.4 1.1-.3 2.2.4 2.4 1.4.3 1.1-.4 2.2-1.4 2.4-.2.1-.3.1-.5.1-.9 0-1.7-.6-1.9-1.5zm37.4-1.2c-1.1-.1-1.9-1.1-1.8-2.2.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2-.1 1-1 1.8-2 1.8h-.2zM91.4 2.6c-.1-1.1.7-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.8 2.2h-.2c-1.1 0-1.9-.7-2-1.8zm7.9-.6c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <circle
                    id="Oval"
                    cx="4.2"
                    cy="153.4"
                    r="4"
                    fill="#FFF"
                    stroke="#DE2414"
                  />
                </g>
                <g id="Group-9" transform="translate(39 44)">
                  <g id="Arm_3">
                    <path
                      id="Path"
                      fill="#F5A1BD"
                      stroke="#DE2414"
                      d="M103.6 11.5c23.2 15.3 39 38.7 44.6 65.9 5.6 27.2.2 55-15.1 78.2a4 4 0 01-5.5 1.1 3.91 3.91 0 01-1.1-5.5c14.1-21.4 19.1-47 13.9-72.1a95.44 95.44 0 00-41.1-60.9"
                    />
                    <g id="Clipped">
                      <mask id="mask-6" fill="#fff">
                        <use xlinkHref="#path-5" />
                      </mask>
                      <g id="Group" mask="url(#mask-6)">
                        <g transform="translate(-56 -3)">
                          <circle
                            className={s.dot}
                            cx="102.3"
                            cy="101.3"
                            r="100"
                          />
                          <g id="Group" strokeWidth="1" opacity=".8">
                            <motion.path
                              initial={{ rotate: 0 }}
                              animate={{
                                rotate: -360,
                                fill: state.participantAcademiaSingle
                                  ? "#fff"
                                  : "#481F7C",
                              }}
                              transition={{
                                repeat: Infinity,
                                duration: 25,
                                ease: "linear",
                                fill: { duration: 0.5 },
                              }}
                              id="Shape"
                              fill="#481F7C"
                              d="M91.1 202.7c-1.1-.1-1.9-1.1-1.8-2.2.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2-.1 1-1 1.8-2 1.8h-.2zm22.2-2c-.1-1.1.6-2.1 1.7-2.2 1.1-.1 2.1.6 2.2 1.7.1 1.1-.6 2.1-1.7 2.2h-.3c-.9.1-1.8-.7-1.9-1.7zm-30.3.8a2 2 0 01-1.6-2.3 2 2 0 012.3-1.6c1.1.2 1.8 1.2 1.6 2.3-.2 1-1 1.6-2 1.6H83zm68.1-12.9c-.6-1-.2-2.2.7-2.7 1-.6 2.2-.2 2.7.7.6 1 .2 2.2-.7 2.7-.3.2-.7.3-1 .3-.6 0-1.3-.3-1.7-1zM45.5 186c-.9-.6-1.2-1.9-.5-2.8.6-.9 1.9-1.2 2.8-.5.9.6 1.2 1.9.5 2.8-.4.6-1 .9-1.7.9-.3 0-.7-.1-1.1-.4zm112.4-1.5c-.6-.9-.4-2.2.5-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.2-.5 2.8-.4.2-.7.4-1.1.4-.6-.1-1.3-.4-1.7-.9zM27 170.1c-.7-.8-.7-2.1.1-2.8.8-.7 2.1-.7 2.8.1.8.8.7 2.1-.1 2.8-.4.4-.9.5-1.4.5-.4.1-1-.2-1.4-.6zm149.1-1.3c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.5-.9.7-1.5.7-.4 0-.9-.1-1.3-.5zm-154.3-4.9c-.7-.9-.5-2.1.4-2.8.9-.7 2.1-.5 2.8.4.7.9.5 2.1-.3 2.8-.4.3-.8.4-1.2.4-.8 0-1.4-.3-1.7-.8zm174.8-29.1c-1.1-.4-1.6-1.5-1.3-2.5.3-1 1.5-1.6 2.5-1.3 1 .4 1.6 1.5 1.3 2.5-.3.8-1.1 1.4-1.9 1.4-.2 0-.4 0-.6-.1zM3.8 127.6c-.3-1.1.4-2.2 1.4-2.4 1.1-.3 2.2.4 2.4 1.4a2 2 0 01-1.4 2.5c-.2 0-.3.1-.5.1-.9-.2-1.7-.7-1.9-1.6zm195.2-.4c-1.1-.3-1.7-1.3-1.5-2.4.3-1.1 1.4-1.7 2.4-1.5 1.1.3 1.7 1.4 1.5 2.4-.2.9-1 1.5-1.9 1.5h-.5zM.3 103.4c0-1.1.8-2 1.9-2 1.1 0 2 .8 2.1 2 0 1.1-.8 2-2 2-1-.1-1.9-.9-2-2zm200-2c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2c-1.1 0-2-.8-2-2zM2.4 97.3c-1.1-.1-2-1-1.9-2.1.1-1.1 1-1.9 2.1-1.9 1.1.1 2 1 1.9 2.1-.1 1.1-.9 1.9-2 1.9h-.1zm190.3-34c-.4-1 0-2.2 1.1-2.6 1-.4 2.2 0 2.6 1.1.4 1 0 2.2-1.1 2.6-.2.1-.5.2-.8.2-.8-.1-1.5-.6-1.8-1.3zM11.8 58.7a2 2 0 01-.9-2.7 2 2 0 012.7-.9 2 2 0 01.9 2.7c-.4.7-1.1 1.1-1.8 1.1-.3 0-.6 0-.9-.2zm177.5-2.5a2 2 0 01.9-2.7c1-.5 2.2-.1 2.7.8a2 2 0 01-.9 2.7c-.3.2-.6.2-.9.2a2 2 0 01-1.8-1zM17.8 47.8c-.9-.6-1.2-1.9-.6-2.8.6-.9 1.9-1.2 2.8-.6.9.6 1.2 1.8.6 2.8-.4.6-1 .9-1.7.9-.4.1-.8 0-1.1-.3zm158.3-11c-.7-.8-.6-2.1.2-2.8.8-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8-.4.3-.8.5-1.3.5s-1.1-.3-1.5-.7zM45.2 19.1c-.6-.9-.4-2.2.6-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.2-.5 2.8-.4.2-.7.3-1.1.3-.7.1-1.4-.2-1.8-.8zm100-6a2 2 0 01-.9-2.7 2 2 0 012.7-.9 2 2 0 01.9 2.7c-.3.7-1 1.1-1.8 1.1-.3 0-.6 0-.9-.2zM66.4 7.9c-.4-1 .2-2.2 1.2-2.6 1-.4 2.2.2 2.6 1.2.4 1-.2 2.2-1.2 2.6-.2.1-.5.1-.7.1-.8.1-1.6-.5-1.9-1.3zM74 5.4a2 2 0 011.4-2.5 2 2 0 012.5 1.4 2 2 0 01-1.4 2.5c-.2 0-.4.1-.5.1-1-.1-1.8-.6-2-1.5zm41.3-1.3c-1.1-.2-1.9-1.2-1.7-2.2.1-1.1 1.2-1.9 2.2-1.7 1.1.1 1.9 1.2 1.7 2.2-.1 1-1 1.7-2 1.7h-.2z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <circle
                    id="Oval"
                    cx="129.8"
                    cy="153.4"
                    r="4"
                    fill="#FFF"
                    stroke="#DE2414"
                  />
                </g>
                <g id="Group-8" transform="translate(39 36)">
                  <g id="Arm_2">
                    <path
                      id="Path"
                      fill="#F5A1BD"
                      stroke="#DE2414"
                      d="M25.6 23C43 9.2 63.8 1.4 85.6.4c5.5-.2 11-.1 16.5.6a103.6 103.6 0 0169.7 38.5 3.98 3.98 0 11-6.2 5 95.32 95.32 0 00-64.3-35.6 95.08 95.08 0 00-70.6 20.3"
                    />
                    <g id="Clipped">
                      <mask id="mask-8" fill="#fff">
                        <use xlinkHref="#path-7" />
                      </mask>
                      <g id="Group" mask="url(#mask-8)">
                        <g transform="translate(-12 2)">
                          <circle
                            className={s.dot}
                            cx="102.4"
                            cy="102.3"
                            r="100"
                          />
                          <g id="Group" strokeWidth="1" opacity=".8">
                            <motion.path
                              initial={{ rotate: 0 }}
                              animate={{
                                rotate: -360,
                                fill: state.participantCivilSingle
                                  ? "#fff"
                                  : "#481F7C",
                              }}
                              transition={{
                                repeat: Infinity,
                                duration: 25,
                                ease: "linear",
                                fill: { duration: 0.5 },
                              }}
                              fill="#481F7C"
                              d="M103 202.3c0-1.1.8-2 1.9-2 1.1 0 2 .8 2.1 1.9 0 1.1-.8 2-2 2.1a2 2 0 01-2-2zm23.8-3a2 2 0 011.4-2.5 2 2 0 012.5 1.4c.3 1.1-.3 2.2-1.4 2.4-.2.1-.4.1-.5.1-1 .1-1.8-.5-2-1.4zm7.7-2.2c-.4-1 .2-2.2 1.2-2.6 1-.4 2.2.2 2.6 1.2.4 1-.2 2.2-1.2 2.6-.2.1-.4.1-.7.1-.9 0-1.7-.5-1.9-1.3zm-69.4.2c-1-.4-1.5-1.6-1.1-2.6.4-1 1.6-1.5 2.6-1.1 1 .4 1.5 1.6 1.1 2.6-.3.8-1.1 1.3-1.9 1.3-.2-.1-.4-.1-.7-.2zm-7.4-3.3a2 2 0 01-.9-2.7 2 2 0 012.7-.9 2 2 0 01.9 2.7c-.4.7-1.1 1.1-1.8 1.1-.3 0-.6 0-.9-.2zm-20.5-13.2c-.8-.7-1-2-.2-2.8.7-.8 2-1 2.8-.3.8.7 1 2 .3 2.8-.4.5-1 .7-1.5.7-.6 0-1.1-.1-1.4-.4zm131.6-3.7c-.8-.8-.7-2.1.1-2.8.8-.8 2.1-.7 2.8.1.8.8.7 2.1-.1 2.8-.4.3-.9.5-1.4.5-.5 0-1-.2-1.4-.6zM22.6 165.9c-.7-.9-.5-2.1.3-2.8.9-.7 2.1-.6 2.8.3.7.9.5 2.1-.3 2.8-.4.3-.8.4-1.2.4-.6.1-1.2-.2-1.6-.7zm-4.8-6.6c-.6-.9-.4-2.2.5-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.2-.5 2.8-.3.2-.7.3-1.1.3-.7.1-1.3-.2-1.7-.8zm166.9-.1c-.9-.6-1.2-1.8-.6-2.8.6-.9 1.8-1.2 2.8-.6.9.6 1.2 1.8.6 2.8-.4.6-1 .9-1.7.9-.4 0-.8-.1-1.1-.3zm4.3-6.8c-1-.5-1.3-1.8-.8-2.7.5-1 1.8-1.3 2.7-.8 1 .5 1.3 1.8.8 2.7-.4.7-1 1-1.8 1-.3.1-.6 0-.9-.2zM6.6 137.6c-.4-1 .2-2.2 1.2-2.6 1-.4 2.2.2 2.6 1.2a2 2 0 01-1.2 2.6c-.2.1-.5.1-.7.1-.8 0-1.6-.5-1.9-1.3zm195-22.8c-1.1-.1-1.9-1.1-1.8-2.2.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2-.1 1-1 1.8-2 1.8h-.2zM2.4 99.6c-1.1-.1-2-1-1.9-2.1 0-1.1 1-2 2.1-1.9 1.1.1 2 1 1.9 2.1-.1 1.1-1 1.9-2.1 1.9zm.5-8c-1.1-.1-1.9-1.1-1.7-2.2.1-1.1 1.1-1.9 2.2-1.7 1.1.1 1.9 1.1 1.7 2.2-.1 1-1 1.7-2 1.7 0 .1-.1.1-.2 0zm196.6-2.5c-.2-1.1.6-2.1 1.7-2.2 1.1-.2 2.1.6 2.2 1.7.1 1.1-.6 2.1-1.7 2.2h-.3c-.9 0-1.8-.7-1.9-1.7zm-1.4-7.7c-.2-1.1.5-2.2 1.5-2.4 1.1-.2 2.2.4 2.4 1.5.2 1.1-.5 2.2-1.5 2.4h-.4c-.9.1-1.8-.6-2-1.5zM8.3 68.3a2 2 0 01-1.1-2.6c.4-1 1.5-1.5 2.6-1.2 1 .4 1.5 1.6 1.1 2.6-.3.8-1.1 1.3-1.9 1.3-.2 0-.5 0-.7-.1zm174.1-22.5c-.6-.9-.4-2.2.5-2.8.9-.6 2.2-.4 2.8.5.6.9.4 2.2-.5 2.8-.3.2-.8.4-1.2.4-.6-.1-1.2-.4-1.6-.9zM29 34.4c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8-.1.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.6 0-1.1-.2-1.4-.5zm5.6-5.7c-.7-.8-.6-2.1.2-2.8.8-.7 2.1-.6 2.8.2.7.8.7 2.1-.2 2.8-.4.3-.9.5-1.3.5-.5 0-1.1-.2-1.5-.7zm132.1-.4c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.5-1 .7-1.5.7s-.9-.1-1.3-.5zm-6.1-4.9c-.9-.7-1.1-1.9-.4-2.8.7-.9 1.9-1.1 2.8-.4.9.7 1.1 1.9.4 2.8-.4.5-1 .8-1.6.8-.5 0-.9-.1-1.2-.4zM54.1 14.7c-.5-1-.1-2.2.8-2.7 1-.5 2.2-.1 2.7.8.5 1 .1 2.2-.8 2.7-.3.2-.6.2-.9.2-.8.1-1.5-.3-1.8-1zM125.3 7c-1.1-.3-1.7-1.3-1.5-2.4.2-1.1 1.3-1.7 2.4-1.5 1.1.3 1.7 1.3 1.5 2.4-.2.9-1 1.5-1.9 1.5-.2.1-.4.1-.5 0zM92 2.8c-.1-1.1.7-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.8 2.2H94c-1.1.1-1.9-.7-2-1.8zm8-.5c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <circle
                    id="Oval"
                    cx="168.6"
                    cy="42"
                    r="4"
                    fill="#FFF"
                    fillRule="nonzero"
                    stroke="#DE2414"
                  />
                </g>
                <g id="Group-11" transform="translate(37)">
                  <g id="Arm_1">
                    <path
                      id="Path"
                      fill="#F5A1BD"
                      stroke="#DE2414"
                      d="M6.7 134.3C-13.4 80.6 13.9 20.5 67.6.4c.4-.2.8-.2 1.2-.3 1.7-.1 3.3.9 3.9 2.6.8 2.1-.3 4.4-2.3 5.2-49.6 18.6-74.8 74-56.2 123.6"
                    />
                    <g id="Clipped">
                      <mask id="mask-10" fill="#fff">
                        <use xlinkHref="#path-9" />
                      </mask>
                      <g id="Group" mask="url(#mask-10)">
                        <g transform="translate(2 -5)">
                          <circle
                            className={s.dot}
                            cx="102.1"
                            cy="102.8"
                            r="100"
                          />
                          <g id="Group" strokeWidth="1" opacity=".8">
                            <motion.path
                              initial={{ rotate: 0 }}
                              animate={{
                                rotate: -360,
                                fill: state.participantGovSingle
                                  ? "#fff"
                                  : "#481F7C",
                              }}
                              transition={{
                                repeat: Infinity,
                                duration: 25,
                                ease: "linear",
                                fill: { duration: 0.5 },
                              }}
                              fill="#481F7C"
                              d="M112 202.4c-.1-1.1.6-2.1 1.8-2.2 1.1-.1 2.1.7 2.2 1.8.1 1.1-.7 2.1-1.7 2.2h-.2c-1.1-.1-2-.8-2.1-1.8zm-28.3.8c-1.1-.2-1.8-1.2-1.6-2.3.2-1.1 1.2-1.8 2.3-1.6 1.1.2 1.8 1.2 1.6 2.3-.2 1-1 1.6-2 1.6h-.3zM68 199c-1-.4-1.6-1.5-1.2-2.5.4-1 1.5-1.6 2.6-1.2 1 .4 1.6 1.5 1.2 2.6-.3.8-1.1 1.3-1.9 1.3-.3-.1-.5-.2-.7-.2zm67.3-1.8a2 2 0 011.2-2.6 2 2 0 012.6 1.2 2 2 0 01-1.2 2.6c-.2.1-.5.1-.7.1-.8 0-1.5-.5-1.9-1.3zm13.3-5.8c-.5-1-.2-2.2.8-2.7s2.2-.2 2.7.8.2 2.2-.8 2.7c-.3.2-.6.2-1 .2-.6 0-1.3-.3-1.7-1zm-102.5-3.3c-.9-.6-1.2-1.9-.6-2.8.6-.9 1.8-1.2 2.8-.6.9.6 1.2 1.9.6 2.8-.4.6-1 .9-1.7.9-.4 0-.7-.1-1.1-.3zm126.6-14.4c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6zM14.1 154.4c-.6-1-.2-2.2.7-2.7 1-.6 2.2-.2 2.7.7.6.9.2 2.2-.7 2.7-.3.2-.7.3-1 .3-.7 0-1.3-.4-1.7-1zm173.4.5c-1-.5-1.3-1.8-.7-2.7.6-1 1.8-1.3 2.7-.7 1 .6 1.3 1.8.7 2.7-.4.6-1 1-1.7 1-.3 0-.7-.1-1-.3zm7.2-14.3c-1-.4-1.5-1.6-1.1-2.6.4-1 1.5-1.6 2.6-1.2a2 2 0 011.1 2.6c-.3.8-1.1 1.3-1.9 1.3-.2.1-.5 0-.7-.1zM4.4 132c-.3-1.1.3-2.2 1.3-2.5 1.1-.3 2.2.3 2.5 1.3.3 1.1-.3 2.2-1.3 2.5-.2.1-.4.1-.6.1-.9 0-1.7-.5-1.9-1.4zm197.4-20.4c-1.1-.1-1.9-1-1.9-2.1.1-1.1 1-1.9 2.1-1.8 1.1.1 1.9 1 1.9 2.1-.1 1-1 1.9-2 1.9 0-.1-.1-.1-.1-.1zM2.1 103.8a2 2 0 01-2-2c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2zm1.1-15.9c-1.1-.2-1.8-1.2-1.6-2.3.2-1.1 1.2-1.8 2.3-1.6 1.1.2 1.8 1.2 1.6 2.3-.2 1-1 1.7-2 1.7-.1-.1-.2-.1-.3-.1zM198.7 86c-.2-1.1.5-2.1 1.6-2.3 1.1-.2 2.1.5 2.3 1.6.2 1.1-.5 2.1-1.6 2.3h-.3c-1 .1-1.9-.6-2-1.6zm-4-15.1c-.4-1 .2-2.2 1.2-2.5 1-.4 2.2.2 2.5 1.2.4 1-.2 2.2-1.2 2.5-.2.1-.4.1-.7.1-.7 0-1.5-.5-1.8-1.3zM9.6 64.8c-1-.4-1.5-1.6-1-2.6.4-1 1.6-1.5 2.6-1 1 .4 1.5 1.6 1 2.6-.3.8-1.1 1.2-1.8 1.2-.3 0-.5-.1-.8-.2zm171.6-19.9c-.7-.9-.5-2.1.4-2.8.9-.7 2.2-.5 2.8.4.7.9.5 2.1-.4 2.8-.4.3-.8.4-1.2.4-.6 0-1.2-.3-1.6-.8zM24.9 39.2c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.5-1 .7-1.5.7-.4-.1-.9-.2-1.3-.5zm11.2-11.5c-.7-.8-.6-2.1.2-2.8.9-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8-.4.3-.8.5-1.3.5-.6 0-1.1-.3-1.5-.7zm129.1.1c-.8-.7-1-2-.2-2.8.7-.8 2-.9 2.8-.2.8.7.9 2 .2 2.8-.4.5-1 .7-1.5.7-.5-.1-1-.2-1.3-.5zm-12.8-9.1c-.9-.6-1.3-1.8-.7-2.7.6-1 1.8-1.3 2.7-.7.9.6 1.3 1.8.7 2.8-.4.6-1 1-1.7 1-.3-.1-.7-.2-1-.4zm-96.6-4.5a2 2 0 01.9-2.7 2 2 0 012.7.9 2 2 0 01-.9 2.7c-.3.1-.6.2-.9.2-.7 0-1.4-.4-1.8-1.1zm69.5-6.6c-1.1-.3-1.7-1.3-1.5-2.4.3-1.1 1.3-1.7 2.4-1.5 1.1.3 1.7 1.3 1.5 2.4-.2.9-1 1.5-2 1.5-.1.1-.3 0-.4 0zM84.1 4.4c-.2-1.1.6-2.1 1.7-2.3 1.1-.2 2.1.6 2.3 1.6.2 1.1-.6 2.1-1.7 2.3h-.3c-1 .1-1.9-.6-2-1.6zM100 2.8c0-1.1.9-2 2-2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <circle
                    id="Oval"
                    cx="69"
                    cy="4.2"
                    r="4"
                    fill="#FFF"
                    stroke="#DE2414"
                  />
                </g>
              </motion.g>
            </g>

            <motion.g
              id="participants"
              initial={{ opacity: 0 }}
              animate={{
                opacity: state.participantLabels ? 1 : 0,
              }}
              transition={{ duration: 0.5 }}
            >
              <motion.g
                id="gov"
                transform="translate(239)"
                initial={{ opacity: 0 }}
                animate={{ opacity: state.participantGov ? 1 : 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.circle
                  id="Oval"
                  cx="50"
                  cy="65.2"
                  r="4"
                  animate={{ opacity: state.participantGovSingle ? 1 : 0 }}
                  fill="#481F7C"
                  stroke="#DE2414"
                />
                <motion.g
                  animate={{ y: state.participantGov ? 0 : -5 }}
                  transition={{ duration: 0.5 }}
                >
                  <g
                    id="Group"
                    fill="#474747"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    // transform="translate(6)"
                    className={s.label}
                  >
                    <text id="Government">
                      <tspan x="50" y="25.2" text-anchor="middle">
                        {getTextSpans(participants[0])}
                      </tspan>
                    </text>
                  </g>
                  <g id="Group" transform="translate(45 38)">
                    <path id="Path" stroke="#474747" d="M5 1v15" />
                    <path
                      id="Path"
                      fill="#474747"
                      d="M1 13l1-1 3 4 3-4 1 1-4 4z"
                    />
                  </g>
                </motion.g>
              </motion.g>

              <motion.g
                id="image-3"
                transform="translate(237 102)"
                initial={{ opacity: 0 }}
                animate={{ opacity: state.participantCivil ? 1 : 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.circle
                  animate={{ opacity: state.participantCivilSingle ? 1 : 0 }}
                  id="Oval"
                  cx="153.6"
                  cy="37"
                  r="4"
                  fill="#481F7C"
                  stroke="#DE2414"
                />

                <motion.g
                  animate={{ x: state.participantCivil ? 0 : 5 }}
                  transition={{ duration: 0.5 }}
                >
                  <g id="Group" transform="translate(163 28)">
                    <path id="Path" stroke="#474747" d="M16 1L1 5" />
                    <path id="Path" fill="#474747" d="M3 1h1L1 5l5 2v1L0 6z" />
                  </g>
                  <g
                    id="Group"
                    fill="#474747"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    transform="translate(182 1)"
                    className={s.label}
                  >
                    <text id="Civil-society">
                      <tspan x="5" y="14" text-anchor="start">
                        {getTextSpans(participants[1], true, 5, 32, "start")}
                      </tspan>
                    </text>
                  </g>
                </motion.g>
              </motion.g>
              <motion.g
                id="image-4"
                transform="translate(237 118)"
                initial={{ opacity: 0 }}
                animate={{ opacity: state.participantAcademia ? 1 : 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.g
                  animate={{ y: state.participantAcademia ? 0 : 5 }}
                  transition={{ duration: 0.5 }}
                >
                  <text
                    id="Academia"
                    fill="#474747"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    className={s.label}
                  >
                    <tspan x="130" y="175">
                      {getTextSpans(participants[2])}
                    </tspan>
                  </text>
                  <g id="Group" transform="translate(120 148)">
                    <path id="Path" stroke="#474747" d="M11 14L1 1" />
                    <path
                      id="Path"
                      fill="#474747"
                      d="M7 2v1L2 2 1 7 0 6l1-6z"
                    />
                  </g>
                </motion.g>
                <motion.circle
                  animate={{ opacity: state.participantAcademiaSingle ? 1 : 0 }}
                  id="Oval"
                  cx="114.8"
                  cy="140.4"
                  r="4"
                  fill="#481F7C"
                  stroke="#DE2414"
                />
              </motion.g>
              <motion.g
                id="image-5"
                transform="translate(112 128)"
                initial={{ opacity: 0 }}
                animate={{ opacity: state.participantPrivate ? 1 : 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.circle
                  animate={{ opacity: state.participantPrivateSingle ? 1 : 0 }}
                  id="Oval"
                  cx="114.2"
                  cy="130.4"
                  r="4"
                  fill="#481F7C"
                  stroke="#DE2414"
                />

                <motion.g
                  animate={{ y: state.participantPrivate ? 0 : 5 }}
                  transition={{ duration: 0.5 }}
                >
                  <g id="Group" transform="translate(98 138)">
                    <path id="Path" stroke="#474747" d="M1 14l9-12" />
                    <path id="Path" fill="#474747" d="M11 7h-1V2L5 3V2l6-1z" />
                  </g>
                  <text
                    id="Private-sector"
                    fill="#474747"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    className={s.label}
                  >
                    <tspan x="94.2" y="165" text-anchor="end">
                      {getTextSpans(participants[3])}
                    </tspan>
                  </text>
                </motion.g>
              </motion.g>
              <motion.g
                id="image-6"
                transform="translate(0 102)"
                initial={{ opacity: 0 }}
                animate={{ opacity: state.participantInter ? 1 : 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.g
                  animate={{ x: state.participantInter ? 0 : -5 }}
                  transition={{ duration: 0.5 }}
                >
                  <g id="Group" transform="translate(161 28)">
                    <path id="Path" stroke="#474747" d="M1 1l15 5" />
                    <path id="Path" fill="#474747" d="M11 9V8l5-2-3-5h1l3 5z" />
                  </g>
                  <g
                    id="Group"
                    fill="#474747"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    transform="translate(1 1)"
                    className={s.label}
                  >
                    <text id="International-and">
                      <tspan x="157.4" y="14" text-anchor="end">
                        {getTextSpans(participants[4], true, 157.4, 32, "end")}
                      </tspan>
                    </text>
                  </g>
                </motion.g>
                <motion.circle
                  animate={{ opacity: state.participantInterSingle ? 1 : 0 }}
                  id="Oval"
                  cx="187.4"
                  cy="37"
                  r="4"
                  fill="#481F7C"
                  stroke="#DE2414"
                />
              </motion.g>
            </motion.g>

            <g transform="translate(42 67)">
              <motion.g
                id="pillars"
                initial={{ opacity: 0 }}
                animate={{
                  rotate: state.pillars ? 0 : -20,
                  opacity: state.pillars ? 1 : 0,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
              >
                <g id="institutions" transform="translate(43 1)">
                  <motion.g
                    animate={{
                      opacity: state.pillarInst ? 1 : 0,
                      x: state.pillarInst ? 0 : -5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Institutions"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="70" y="14" textAnchor="end">
                        {getTextSpans(pillars[0], true, 70, 14, "end")}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(76.25 5.3)">
                      <line
                        id="Path"
                        x1="0"
                        x2="15.7"
                        y1="4.7"
                        y2="4.7"
                        stroke="#474747"
                      />
                      <polygon
                        id="Path"
                        fill="#474747"
                        fillRule="nonzero"
                        points="12.3 8.8 11.7 8.1 15.3 4.7 11.7 1.4 12.3 .7 16.7 4.7"
                      />
                    </g>
                  </motion.g>

                  <path
                    id="Path"
                    fill="#0C5860"
                    stroke="#DE2414"
                    d="M118 20h-16l-2-2V2l2-2h16l2 2v16l-2 2z"
                  />

                  <motion.path
                    animate={{ fillOpacity: state.pillarInstSingle ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                    id="Path"
                    fill="#481F7C"
                    stroke="#DE2414"
                    d="M118 20h-16l-2-2V2l2-2h16l2 2v16l-2 2z"
                  />

                  <path
                    id="Rectangle"
                    fill="#FFF"
                    d="M106 7h7v7h-7z"
                    transform="rotate(45 110 10)"
                  />
                </g>
                <g id="economic" transform="translate(0 189)">
                  <path
                    id="Path"
                    fill="#0C5860"
                    stroke="#DE2414"
                    d="M162 2v16l-1 2h-17l-2-2V2l2-2h17l1 2z"
                  />

                  <motion.path
                    animate={{ fillOpacity: state.pillarEconSingle ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                    id="Path"
                    fill="#481F7C"
                    stroke="#DE2414"
                    d="M162.22 1.76v16.6c0 .9-.8 1.7-1.7 1.7h-16.6c-.9 0-1.7-.8-1.7-1.7V1.76c0-.9.8-1.7 1.7-1.7h16.6c1 0 1.7.7 1.7 1.7z"
                  />
                  <g
                    id="Group"
                    fill="#FFF"
                    fillRule="nonzero"
                    transform="translate(146.52 5.76)"
                  >
                    <path
                      id="Path"
                      d="M6.5 3.5l.7-.7a3.87 3.87 0 00-5.3 0C1.2 3.5.8 4.4.8 5.5c0 1 .4 1.9 1.1 2.7l.7-.7c-.5-.5-.8-1.2-.8-1.9s.3-1.4.8-1.9c1-1.2 2.8-1.2 3.9-.2z"
                    />
                    <path
                      id="Path"
                      d="M9.6.4l-.7.7C10 2.2 10 3.9 8.9 5A2.72 2.72 0 015 5l-.7.7C5 6.4 6 6.8 7 6.8c1 0 1.9-.4 2.7-1.1 1.4-1.5 1.4-3.9-.1-5.3z"
                    />
                  </g>

                  <motion.g
                    animate={{
                      opacity: state.pillarEcon ? 1 : 0,
                      x: state.pillarEcon ? 0 : -5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Economic-policies"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="110" y="14" text-anchor="end">
                        {getTextSpans(pillars[2], true, 110, 14, "end")}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(119 6)">
                      <path id="Path" stroke="#474747" d="M0 4h16" />
                      <path id="Path" fill="#474747" d="M12 8l3-4-3-3V0l5 4z" />
                    </g>
                  </motion.g>
                </g>
                <g id="laws" transform="translate(331.3 189.24)">
                  <path
                    id="Path"
                    fill="#0C5860"
                    stroke="#DE2414"
                    d="M2 0h16l2 2v16l-2 2H2l-2-2V2l2-2z"
                  />

                  <motion.path
                    animate={{ fillOpacity: state.pillarLawsSingle ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                    id="Path"
                    fill="#481F7C"
                    stroke="#DE2414"
                    d="M2 0h16l2 2v16l-2 2H2l-2-2V2l2-2z"
                  />

                  <path
                    id="Path"
                    fillRule="nonzero"
                    stroke="#DE2414"
                    d="M1.7.06h16.6c.9 0 1.7.8 1.7 1.7v16.6c0 .9-.8 1.7-1.7 1.7H1.7c-.9 0-1.7-.8-1.7-1.7V1.76C0 .76.7.06 1.7.06z"
                  />
                  <polygon
                    id="Path"
                    fill="#FFF"
                    fillRule="nonzero"
                    points="15 9.56 11.2 9.56 13.8 6.86 13.1 6.16 10.5 8.76 10.5 5.06 9.5 5.06 9.5 8.76 6.8 6.16 6.1 6.86 8.7 9.56 5 9.56 5 10.56 8.7 10.56 6.1 13.16 6.8 13.86 9.5 11.26 9.5 15.06 10.5 15.06 10.5 11.26 13.1 13.86 13.8 13.16 11.2 10.56 15 10.56"
                  />

                  <motion.g
                    animate={{
                      opacity: state.pillarLaws ? 1 : 0,
                      x: state.pillarLaws ? 0 : 5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Laws-and-regulations"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="46" y="14">
                        {getTextSpans(pillars[1], true, 46, 14, "start")}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(26.7 5.76)">
                      <line
                        id="Path"
                        x1="17"
                        x2="1.3"
                        y1="4.3"
                        y2="4.3"
                        stroke="#474747"
                      />
                      <polygon
                        id="Path"
                        fill="#474747"
                        fillRule="nonzero"
                        points="4.7 .2 5.3 .9 1.7 4.3 5.3 7.6 4.7 8.3 .3 4.3"
                      />
                    </g>
                  </motion.g>
                </g>
                <g id="infra" transform="translate(331 1)">
                  <path
                    id="Path"
                    fill="#0C5860"
                    fillRule="nonzero"
                    stroke="#DE2414"
                    d="M0 18.3V1.7C0 .8.8 0 1.7 0h16.6c.9 0 1.7.8 1.7 1.7v16.6c0 .9-.8 1.7-1.7 1.7H1.7c-1 0-1.7-.7-1.7-1.7z"
                  />
                  <polygon
                    id="Path"
                    fill="#FFF"
                    fillRule="nonzero"
                    points="10 5.7 12.5 10 15 14.4 10 14.4 5 14.4 7.5 10"
                  />

                  <motion.path
                    animate={{ fillOpacity: state.pillarInfraSingle ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                    id="Path"
                    fill="#481F7C"
                    stroke="#DE2414"
                    d="M0 18.3V1.7C0 .8.8 0 1.7 0h16.6c.9 0 1.7.8 1.7 1.7v16.6c0 .9-.8 1.7-1.7 1.7H1.7c-1 0-1.7-.7-1.7-1.7z"
                  />

                  <polygon
                    id="Path"
                    fill="#FFF"
                    fillRule="nonzero"
                    points="10 5.7 12.5 10 15 14.4 10 14.4 5 14.4 7.5 10"
                  />

                  <motion.g
                    animate={{
                      opacity: state.pillarInfra ? 1 : 0,
                      x: state.pillarInfra ? 0 : 5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Infrastructure-policies"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="46" y="14">
                        {getTextSpans(pillars[3], true, 46, 14, "start")}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(26.7 5.3)">
                      <line
                        id="Path"
                        x1="17"
                        x2="1.3"
                        y1="4.7"
                        y2="4.7"
                        stroke="#474747"
                      />
                      <polygon
                        id="Path"
                        fill="#474747"
                        fillRule="nonzero"
                        points="4.7 .7 5.3 1.4 1.7 4.7 5.3 8.1 4.7 8.8 .3 4.7"
                      />
                    </g>
                  </motion.g>
                </g>
              </motion.g>
            </g>

            <g transform="translate(44 3)">
              <motion.g
                id="foundations"
                initial={{ opacity: 0 }}
                animate={{
                  rotate: state.foundations ? 0 : 20,
                  scale: state.foundations ? 1 : 0.5,
                  opacity: state.foundations ? 1 : 0,
                }}
                transition={{ duration: 0.5, ease: "backOut" }}
              >
                <g
                  id="bg-circle"
                  stroke="#FAAD62"
                  strokeLinecap="round"
                  strokeWidth="8"
                  transform="translate(85 9)"
                >
                  <path
                    id="Path"
                    d="M65 289a159 159 0 00189 1M8 112a159 159 0 0057 177M160 0C89 0 28 47 8 112M312 111C291 46 231 0 160 0M254 290a160 160 0 0058-179"
                  />
                </g>
                <g id="data-demand" transform="translate(52 1)">
                  <motion.g
                    animate={{
                      opacity: state.foundationsData ? 1 : 0,
                      y: state.foundationsData ? 0 : -5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Data-demand"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="80" y="14" textAnchor="end">
                        {getTextSpans(foundations[4])}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(84 18)">
                      <path id="Path" stroke="#474747" d="M0 1l10 12" />
                      <path
                        id="Path"
                        fill="#474747"
                        d="M4 13l1-1 4 1 1-5h1l-1 6z"
                      />
                    </g>
                  </motion.g>
                </g>
                <g id="incentives" transform="translate(0 116)">
                  <motion.g
                    animate={{
                      opacity: state.foundationsIncentives ? 1 : 0,
                      y: state.foundationsIncentives ? 0 : 5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Incentives"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="60" y="114" text-anchor="end">
                        {getTextSpans(foundations[3])}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(69 102)">
                      <path id="Path" stroke="#474747" d="M0 8l15-5" />
                      <path
                        id="Path"
                        fill="#474747"
                        d="M13 8h-1l3-5-5-2 1-1 5 3z"
                      />
                    </g>
                  </motion.g>
                </g>
                <g id="funding" transform="translate(146 294)">
                  <motion.g
                    animate={{
                      opacity: state.foundationsFunding ? 1 : 0,
                      y: state.foundationsFunding ? 0 : 5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Funding"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="102" y="73" text-anchor="middle">
                        {getTextSpans(foundations[2])}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(94 43)">
                      <path id="Path" stroke="#474747" d="M5 17V1" />
                      <path
                        id="Path"
                        fill="#474747"
                        d="M9 4L8 5 5 2 2 5 1 4l4-4z"
                      />
                    </g>
                  </motion.g>
                </g>
                <g id="trust" transform="translate(335 116)">
                  <motion.g
                    animate={{
                      opacity: state.foundationsTrust ? 1 : 0,
                      y: state.foundationsTrust ? 0 : 5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Trust"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="89" y="115">
                        {getTextSpans(foundations[1])}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(69 102)">
                      <path id="Path" stroke="#474747" d="M17 8L2 3" />
                      <path
                        id="Path"
                        fill="#474747"
                        d="M6 0l1 1-5 2 3 5H4L1 3z"
                      />
                    </g>
                  </motion.g>
                </g>
                <g id="human-capital" transform="translate(241 1)">
                  <path
                    transform="rotate(72, 4, 168)"
                    stroke="#DE2414"
                    d="M156 123l-4-3A156 156 0 004 12c-2 0-4-1-4-4 0-2 2-4 4-4a163 163 0 01156 114c1 2 0 4-3 5h-1z"
                  />

                  <path
                    transform="rotate(144, 4, 168)"
                    stroke="#DE2414"
                    d="M156 123l-4-3A156 156 0 004 12c-2 0-4-1-4-4 0-2 2-4 4-4a163 163 0 01156 114c1 2 0 4-3 5h-1z"
                  />

                  <path
                    transform="rotate(216, 4, 168)"
                    stroke="#DE2414"
                    d="M156 123l-4-3A156 156 0 004 12c-2 0-4-1-4-4 0-2 2-4 4-4a163 163 0 01156 114c1 2 0 4-3 5h-1z"
                  />

                  <path
                    transform="rotate(288, 4, 168)"
                    stroke="#DE2414"
                    d="M156 123l-4-3A156 156 0 004 12c-2 0-4-1-4-4 0-2 2-4 4-4a163 163 0 01156 114c1 2 0 4-3 5h-1z"
                  />

                  <path
                    transform="rotate(360, 4, 168)"
                    stroke="#DE2414"
                    d="M156 123l-4-3A156 156 0 004 12c-2 0-4-1-4-4 0-2 2-4 4-4a163 163 0 01156 114c1 2 0 4-3 5h-1z"
                  />

                  <motion.g
                    animate={{
                      opacity: state.foundationsHuman ? 1 : 0,
                      y: state.foundationsHuman ? 0 : -5,
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <text
                      id="Human-capital"
                      fill="#474747"
                      fontFamily="Helvetica"
                      fontSize="14"
                      fontWeight="normal"
                      className={s.label}
                    >
                      <tspan x="119" y="14">
                        {getTextSpans(foundations[0])}
                      </tspan>
                    </text>
                    <g id="Group" transform="translate(102 18)">
                      <path id="Path" stroke="#474747" d="M11 1L1 13" />
                      <path
                        id="Path"
                        fill="#474747"
                        d="M0 8h1l1 5 4-1 1 1-6 1z"
                      />
                    </g>
                  </motion.g>
                </g>
              </motion.g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default IntegratedNationalDataSystem;
